<template>
<div class="containers">
    <div v-if="goArea == true" class="area-list">
        <div class="search-area">
            <CRow>
                <CCol sm="4">
                    <input type="text" v-model="searchKantor" placeholder="Cari Kantor" class="form-control"/>
                </CCol>
                <CCol sm="3">
                    <model-select style="background-color:rgba(249, 250, 252, 1)" :options="dataJenisTest" class="form-control" v-model="jenisTest" placeholder="Pilih Jenis Tes"></model-select>
                </CCol>
                <CCol sm="3">
                    <input type="date" v-model="searchTanggal" placeholder="Tanggal Pelaksanaan" class="form-control"/>
                </CCol>
                <CCol sm="2">
                    <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
                </CCol>
            </CRow>
        </div>
        <div class="sticky1">
            <CRow>
                <CCol sm="6"></CCol>
                <CCol sm="6">
                    <span style="float:right">
                        <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                        <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    </span>
                    <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                    <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                    <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                    <img class="mt-1 mr-5" :src="moreIcon" width="20px" height="20px" style="float:right"/>
                    <img class="mr-5 mt-1" @click="reload()" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="float:right;cursor:pointer"/>
                </CCol>
            </CRow>
        </div>
        <Tables @sort="sorting" @edit="editData" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
    </div>
    <div v-else class="area-edit">
        <CModal
            size="lg"
            :centered="true"
            color="white"
            :show.sync="modalImport"
            :closeOnBackdrop="false"
            >
            <template #header-wrapper>
                <div class="headers-modal">
                    <CRow>
                        <CCol sm="8">
                            <div>Import Hasil Tes</div>
                        </CCol>
                        <CCol class="text-right" sm="3">
                            <CButton color="success" @click="exportTemplate()" variant='outline'>Export Template</CButton>
                        </CCol>
                        <CCol sm="1" class="text-right">
                            <img :src="closeIcon" @click="closeModalImport()" style="cursor:pointer" width="20px" height="20px"/>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #body-wrapper>
                <div class="mb-5" style="padding-right:20px;padding-left:20px">
                    <CRow>
                        <CCol sm="6">
                            <div>
                                <CButton style="width:200px" color="primary" onclick="document.getElementById('inputFile').click()" variant='outline'>
                                    <span><font-awesome-icon class="mr-2" :icon="{prefix: 'fas', iconName: 'upload'}" />Import Excel</span>
                                    <!-- <CSpinner v-else color="default" size="sm"/> -->
                                </CButton>
                                <input type="file" @change="submitImport()" style="display:none" accept=".xls, .xlsx" id="inputFile" class="hide" />
                            </div>
                        </CCol>
                        <CCol v-if="dataImport.length != 0" sm="6">
                            <CRow>
                                <CCol sm="6">
                                    Total Data
                                </CCol>
                                <CCol sm="6">
                                    : {{totalDataImport}}
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol sm="6">
                                    Total Data Tidak Valid
                                </CCol>
                                <CCol sm="6">
                                    : {{dataJumlahTidakValid}}
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol sm="6">
                                    Total Data Valid
                                </CCol>
                                <CCol sm="6">
                                    : {{dataJumlahValid}}
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol sm="6">
                                    Total Data Reaktif
                                </CCol>
                                <CCol sm="6">
                                    : {{dataJumlahReaktif}}
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol sm="6">
                                    Total Data Non Reaktif
                                </CCol>
                                <CCol sm="6">
                                    : {{dataJumlahNonReaktif}}
                                </CCol>
                            </CRow>
                        </CCol>
                    </CRow>
                    <CRow v-if="dataImport.length != 0" class="mt-4">
                        <CCol sm="12">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Nama</th>
                                        <th>NIP</th>
                                        <th>Hasil</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(li, id) in dataImport" :key="id">
                                        <td>{{li.nama}}</td>
                                        <td>{{li.nik}}</td>
                                        <td>{{li.hasil}}</td>
                                        <td>{{li.status}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </CCol>
                    </CRow>
                </div>
                <CRow class="mt-5" style="padding-bottom:40px;padding-left:20px;padding-right:20px">
                    <CCol class="text-right" sm="12">
                        <CButton v-if="flagImport == true && dataJumlahValid != '0'" style="float:right" @click="simpanImport()" class="w-25 ml-2" color="primary">Simpan</CButton>
                        <CButton style="float:right" @click="closeModalImport()" class="btn-cancel w-25">Kembali</CButton>
                    </CCol>
                </CRow>
            </template>
            <template #footer-wrapper><span></span></template>
        </CModal>
        <CModal
            size="lg"
            :centered="true"
            color="white"
            :show.sync="modalAdd"
            :closeOnBackdrop="false"
            >
            <template #header-wrapper>
                <div class="headers-modal">
                    <CRow>
                        <CCol sm="10">
                            <div>Penambahan Manual Peserta Tes</div>
                        </CCol>
                        <CCol sm="2" class="text-right">
                            <img :src="closeIcon" @click="closeAdd()" style="cursor:pointer" width="20px" height="20px"/>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #body-wrapper>
                <div style="padding-right:20px;padding-left:20px">
                    <CRow>
                        <CCol sm="6">
                            <label>Nama Peserta Tes</label>
                            <div class="autocomplete">
                                <input type="text"
                                        class="form-control"
                                        @click="toggleVisibleAddPegawai()"
                                        @blur="toggleCloseVisibleAddPegawai()"
                                        v-model="queryAddPegawai"
                                        v-text="selectedItemAddPegawai ? selectedItemAddPegawai['text'] : ''"
                                        @keydown.up="upAddPegawai"
                                        @keydown.down="downAddPegawai"
                                        @keydown.enter="selectItemAddPegawai"
                                        placeholder="Pilih Pegawai"
                                >
                                <div class="popovers" v-show="visibleAddPegawai">
                                    <div class="options" v-if="matchesAddPegawai.length != 0 && queryAddPegawai.length != 0" ref="optionsList">
                                        <ul>
                                        <li v-for="(match, index) in matchesAddPegawai"
                                            :key="index"
                                            :class="{ 'selected': (selectedAddPegawai == index)}"
                                            @click="itemClickedAddPegawai(index)"
                                            v-text="match['text']"></li>
                                        </ul>
                                    </div>
                                    <div class="options" v-if="matchesAddPegawai.length == 0 && queryAddPegawai.length != 0">
                                        Data Tidak Ditemukan
                                    </div>
                                    <div class="options" v-if="matchesAddPegawai.length == 0 && queryAddPegawai.length == 0">
                                        Start Typing...
                                    </div>
                                </div>
                            </div>
                        </CCol>
                    </CRow>
                    <CRow class="mt-2">
                        <CCol sm="6">
                            <label>Nomor KTP</label>
                            <input :disabled="newKtp!='Y'" onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" placeholder="NIK" v-model="noKtpAddPegawai" class="form-control"/>
                        </CCol>
                        <CCol sm="6">
                            <label>Tanggal Lahir</label>
                            <input type="date" :disabled="newTtl!='Y'" v-model="ttlAddPegawai" class="form-control"/>
                        </CCol>
                    </CRow>
                    <CRow class="mt-3 mb-5">
                        <CCol sm="12">
                            <label>Jam Pelaksanaan</label>
                            <model-select style="background-color:rgba(249, 250, 252, 1)" :options="dataJadwal" class="form-control" v-model="jadwal" placeholder="Jadwal Pelaksanaan"></model-select>
                        </CCol>
                    </CRow>
                </div>
                <CRow class="mt-5" style="padding-bottom:40px;padding-left:20px;padding-right:20px">
                    <CCol sm="6"></CCol>
                    <CCol sm="3">
                        <CButton style="width: 100%!important" @click="closeAdd()" class="btn-cancel">Kembali</CButton>
                    </CCol>
                    <CCol sm="3">
                        <CButton @click="addPeserta()" class="w-100" color="primary">Simpan</CButton>
                    </CCol>
                </CRow>
            </template>
            <template #footer-wrapper><span></span></template>
        </CModal>
        <CModal
            size="lg"
            :centered="true"
            color="white"
            :show.sync="modalHasil"
            :closeOnBackdrop="false"
            >
            <template #header-wrapper>
                <div class="headers-modal">
                    <CRow>
                        <CCol sm="10">
                            <div><span v-if="datasDetail[dataShowHasil].edit == 'Y'">Konfirmasi </span>Hasil Tes {{dataJenisTes}} Peserta</div>
                        </CCol>
                        <CCol sm="2" class="text-right">
                            <img :src="closeIcon" @click="modalHasil = false" style="cursor:pointer" width="20px" height="20px"/>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #body-wrapper>
                <div style="padding-right:20px;padding-left:20px">
                    <CRow>
                        <CCol sm="3">
                            Nama
                        </CCol>
                        <CCol sm="9">
                            :  <span class="font-weight-bold">{{datasDetail[dataShowHasil].nama}}</span>
                        </CCol>
                    </CRow>
                    <CRow class="mt-2">
                        <CCol sm="3">
                            NIP
                        </CCol>
                        <CCol sm="9">
                            :  {{datasDetail[dataShowHasil].nik}}
                        </CCol>
                    </CRow>
                    <CRow class="mt-2">
                        <CCol sm="3">
                            Nomor KTP
                        </CCol>
                        <CCol sm="9">
                            :  {{datasDetail[dataShowHasil].noKtp}}
                        </CCol>
                    </CRow>
                    <CRow class="mt-2">
                        <CCol sm="3">
                            Tanggal Lahir
                        </CCol>
                        <CCol sm="9">
                            :  {{datasDetail[dataShowHasil].tanggalLahir}}
                        </CCol>
                    </CRow>
                    <CRow class="mt-2">
                        <CCol sm="3">
                            Nama Atasan
                        </CCol>
                        <CCol sm="9">
                            :  {{datasDetail[dataShowHasil].namaAtasan}}
                        </CCol>
                    </CRow>
                    <CRow v-if="datasDetail[dataShowHasil].idStatus != '10'" class="mt-2">
                        <CCol sm="3">
                            Hasil Tes
                        </CCol>
                        <CCol sm="9">
                            :  <span class="font-weight-bold" :style="'color:'+datasDetail[dataShowHasil].color">{{datasDetail[dataShowHasil].status}}</span>
                        </CCol>
                    </CRow>
                    <CRow v-if="datasDetail[dataShowHasil].idStatus != '10'" class="mt-2">
                        <CCol sm="12">
                        <CButton style="width: 25%!important" @click="showPdfHasil(datasDetail[dataShowHasil].unix)" variant="outline" class="btn-danger">Export Hasil Tes (Template)</CButton>
                        </CCol>
                    </CRow>
                    <CRow v-if="datasDetail[dataShowHasil].idStatus != '10' && datasDetail[dataShowHasil].urlKlinik != '-'" class="mt-2">
                        <CCol sm="12">
                        <CButton style="width: 25%!important" @click="showPdfHasilKlinik(datasDetail[dataShowHasil].urlKlinik)" variant="outline" class="btn-danger">Export Hasil Tes (Klinik)</CButton>
                        </CCol>
                    </CRow>
                    <CRow v-if="datasDetail[dataShowHasil].idStatus != '10' && datasDetail[dataShowHasil].urlKlinik == '-'" class="mt-4">
                        <CCol sm="3">
                            Upload Hasil Tes Dari Klinik
                        </CCol>
                        <CCol sm="9">
                            <CButton v-if="datasDetail[dataShowHasil].urlKlinik == '-'" type="button" onclick="document.getElementById('inputFilePDF').click()" class="btn btn-cancel">Pilih File Maks 2MB</CButton>
                            <input type="file" accept=".pdf, .PDF" @change="loadFile()" style="display:none"  id="inputFilePDF" class="hide" />
                        </CCol>
                    </CRow>
                </div>
                <CRow class="mt-5" style="padding-bottom:40px;padding-left:20px;padding-right:20px">
                    <CCol v-if="datasDetail[dataShowHasil].edit == 'V'" sm="12"></CCol>
                    <CCol v-if="datasDetail[dataShowHasil].edit == 'Y'" sm="8"></CCol>
                    <CCol sm="2">
                        <CButton v-if="datasDetail[dataShowHasil].edit == 'Y'" @click="submitHasil('1')" class="w-100" color="danger"><span v-if="idJenisTes == '11'">Positif</span><span span v-if="idJenisTes == '12'">Reaktif</span></CButton>
                    </CCol>
                    <CCol sm="2">
                        <CButton v-if="datasDetail[dataShowHasil].edit == 'Y'" @click="submitHasil('2')" class="w-100" color="primary"><span v-if="idJenisTes == '11'">Negatif</span><span span v-if="idJenisTes == '12'">Non Reaktif</span></CButton>
                    </CCol>
                </CRow>
            </template>
            <template #footer-wrapper><span></span></template>
        </CModal>
        <CModal
            size="lg"
            :centered="true"
            color="white"
            :show.sync="modalDelete"
            :closeOnBackdrop="false"
            >
            <template #header-wrapper>
                <div class="headers-modal">
                    <CRow>
                        <CCol sm="10">
                            <div>Konfirmasi Hapus Peserta Tes</div>
                        </CCol>
                        <CCol sm="2" class="text-right">
                            <img :src="closeIcon" @click="modalDelete = false" style="cursor:pointer" width="20px" height="20px"/>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #body-wrapper>
                <div style="padding-right:20px;padding-left:20px">
                    <CRow>
                        <CCol sm="12">
                            Apakah anda yakin ingin menghapus <span class="font-weight-bold">{{datasDetail[dataShowHasil].nama}}</span> dari daftar peserta tes?
                        </CCol>
                    </CRow>
                </div>
                <CRow class="mt-5" style="padding-bottom:40px;padding-left:20px;padding-right:20px">
                    <CCol sm="8"></CCol>
                    <CCol sm="2">
                        <CButton style="width: 100%!important" @click="modalDelete = false" class="btn-cancel">Batal</CButton>
                    </CCol>
                    <CCol sm="2">
                        <CButton @click="deletePeserta()" class="w-100" color="danger">Ya, Hapus</CButton>
                    </CCol>
                </CRow>
            </template>
            <template #footer-wrapper><span></span></template>
        </CModal>
        <CModal
            size="lg"
            :centered="true"
            color="white"
            :show.sync="modalHadir"
            :closeOnBackdrop="false"
            >
            <template #header-wrapper>
                <div class="headers-modal">
                    <CRow>
                        <CCol sm="10">
                            <div>Konfirmasi Kehadiran Peserta</div>
                        </CCol>
                        <CCol sm="2" class="text-right">
                            <img :src="closeIcon" @click="modalHadir = false" style="cursor:pointer" width="20px" height="20px"/>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #body-wrapper>
                <div style="padding-right:20px;padding-left:20px">
                    <CRow>
                        <CCol sm="3">
                            Nama
                        </CCol>
                        <CCol sm="9">
                            :  <span class="font-weight-bold">{{datasDetail[dataShowHasil].nama}}</span>
                        </CCol>
                    </CRow>
                    <CRow class="mt-2">
                        <CCol sm="3">
                            NIP
                        </CCol>
                        <CCol sm="9">
                            :  {{datasDetail[dataShowHasil].nik}}
                        </CCol>
                    </CRow>
                    <CRow class="mt-2">
                        <CCol sm="3">
                            Nomor KTP
                        </CCol>
                        <CCol sm="9">
                            :  {{datasDetail[dataShowHasil].noKtp}}
                        </CCol>
                    </CRow>
                    <CRow class="mt-2">
                        <CCol sm="3">
                            Tanggal Lahir
                        </CCol>
                        <CCol sm="9">
                            :  {{datasDetail[dataShowHasil].tanggalLahir}}
                        </CCol>
                    </CRow>
                    <CRow class="mt-2">
                        <CCol sm="3">
                            Nama Atasan
                        </CCol>
                        <CCol sm="9">
                            :  {{datasDetail[dataShowHasil].namaAtasan}}
                        </CCol>
                    </CRow>
                    <CRow class="mt-5" style="padding-bottom:40px;">
                        <CCol sm="8"></CCol>
                        <CCol sm="2">
                            <CButton style="width: 100%!important" @click="modalHadir = false" class="btn-cancel">Batal</CButton>
                        </CCol>
                        <CCol sm="2">
                            <CButton @click="submitHadir()" class="w-100" color="primary">Ya, Hadir</CButton>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #footer-wrapper><span></span></template>
        </CModal>
        <CRow class="area-back">
            <CCol sm="12">
                <img class="mt-2 mb-2" @click="moving()" :src="backIcon" width="20px" height="20px" style="float:left;cursor:pointer"/>
            </CCol>
        </CRow>
        <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
        <div style="padding-top: 12px;padding-left: 20px;padding-right: 20px;padding-bottom: 6px !important;background-color: white;">
            <CRow>
                <CCol sm="9">
                    <CRow>
                        <CCol sm="4">
                            <span>Nama Lokasi</span>
                        </CCol>
                        <CCol sm="8">
                            : <span class="font-weight-bold">{{dataNamaKantor}}</span>
                        </CCol>
                    </CRow>
                    <CRow class="mt-1">
                        <CCol sm="4">
                            <span>Tanggal</span>
                        </CCol>
                        <CCol sm="8">
                            : {{dataTanggal}}
                        </CCol>
                    </CRow>
                    <CRow class="mt-1">
                        <CCol sm="4">
                            <span>Jenis Tes</span>
                        </CCol>
                        <CCol sm="8">
                            : {{dataJenisTes}}
                        </CCol>
                    </CRow>
                    <CRow class="mt-1">
                        <CCol sm="4">
                            <span>Total Mendaftar</span>
                        </CCol>
                        <CCol sm="8">
                            : {{dataTotalMendaftar}} Peserta
                        </CCol>
                    </CRow>
                    <CRow class="mt-1">
                        <CCol sm="4">
                            <span>Total Reaktif/Positif</span>
                        </CCol>
                        <CCol sm="8">
                            : {{dataTotalReaktif}} Peserta
                        </CCol>
                    </CRow>
                    <CRow class="mt-1">
                        <CCol sm="4">
                            <span>Total Non Reaktif/Negatif</span>
                        </CCol>
                        <CCol sm="8">
                            : {{dataTotalNonReaktif}} Peserta
                        </CCol>
                    </CRow>
                    <CRow class="mt-3">
                        <CCol sm="12 mb-1">
                            <span>Link URL untuk petugas input hasil</span>
                        </CCol>
                        <CCol sm="10">
                            <input class="form-control" v-model="dataUrlCopy" disabled />
                        </CCol>
                        <CCol sm="2">
                            <CButton 
                            @click="copyUrl()" 
                            color="info" 
                            class="w-100" 
                            variant="outline">
                                <span v-if="flagCopy == false">Copy</span>
                                <span v-if="flagCopy == true">Copied!</span>
                            </CButton>
                        </CCol>
                    </CRow>
                </CCol>
                <CCol sm="3 text-center">
                    <img v-if="imageQR != ''" :src="'data:image/jpeg;base64,' + imageQR" style="border-radius: 8px" width="150" height="150"/>
                    <CRow class="mt-2">
                        <CCol sm="12">
                            <CButton @click="exportPdf()" color="danger" variant="outline">Export QR Code</CButton>
                        </CCol>
                    </CRow>
                </CCol>
            </CRow>
        </div>
        <hr class="mt-3 mb-2" />
        <div class="search-area ">
            <CAlert
            v-if="success == true"
            :show.sync="currentAlertCounter"
            closeButton
            style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
            >
            {{alertMess}}
            </CAlert>
            <CAlert
            v-else
            :show.sync="currentAlertCounter"
            closeButton
            style="background-color:red;border-radius:0;text-align:center;color:white"
            >
            {{alertMess}}
            </CAlert>
            <CRow>
                <CCol sm="6" class="pr-1">
                    <input type="text" v-model="idPegawai" placeholder="Cari Pegawai" class="form-control"/>
                </CCol>
                <CCol sm="2" class="pr-1 pl-1">
                    <model-select style="background-color:rgba(249, 250, 252, 1)" :options="dataFilterJam" class="form-control" v-model="filterJam" placeholder="Jam Pelaksanaan"></model-select>
                </CCol>
                <CCol sm="2" class="pr-1 pl-1">
                    <model-select style="background-color:rgba(249, 250, 252, 1)" :options="dataFilterStatus" class="form-control" v-model="filterStatus" placeholder="Status"></model-select>
                </CCol>
                <CCol sm="2 pl-1">
                    <CButton @click="findDataDetail()" type="button" class="btn btn-search">Cari</CButton>
                </CCol>
            </CRow>
        </div>
        <div class="sticky1">
            <CRow>
                <CCol v-if="flagAddKantor != 'Y'" sm="6"><CButton v-if="allowImport == 'Y'" @click="importExcel()" color="success" variant="outline">Import excel hasil tes</CButton></CCol>
                <CCol v-if="flagAddKantor == 'Y'" sm="4"><CButton v-if="allowImport == 'Y'" @click="importExcel()" color="success" variant="outline">Import excel hasil tes</CButton></CCol>
                <CCol sm="6">
                    <span style="float:right">
                        <CButton v-if="pageDetail == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-else @click="movePageDetail('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-if="pageDetail == totalPageDetail" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                        <CButton v-else @click="movePageDetail('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    </span>
                    <input @change="validatePageDetail(pageDetail)" v-if="totalPageDetail != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="pageDetail" class="text-center rounded p-1" type="text">
                    <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="pageDetail" class="text-center rounded p-1" type="text">
                    <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPageDetail}} - {{lastPageDetail}}</span> of {{totalRowDetail}}</span>
                    <img class="mt-1 mr-4" :src="moreIcon" width="20px" height="20px" style="float:right"/>
                    <img class="mr-4 mt-1" v-if="datasDetail.length != 0" @click="getDownload()" style="float:right;cursor:pointer" :src="downloadIcon" title="export to excel"  width="20px" height="20px"/>
                    <!-- <img class="mr-4 mt-1" @click="reloadDetail()" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="float:right;cursor:pointer"/> -->
                </CCol>
                <CCol sm="2 pl-1">
                    <CButton v-if="flagAddKantor == 'Y'" @click="modalAdd = true" type="button" class="btn btn-add">Tambah</CButton>
                </CCol>
            </CRow>
        </div>
        <div class="tableFixHead sticky2">
            <table>
                <thead class="text-center">
                    <tr>
                        <th class="text-left" style="width:100px;max-width:100px">Nama Pegawai</th>
                        <th class="text-left" style="width:75px;max-width:75px">Nomor KTP</th>
                        <th class="text-left" style="width:60px;max-width:60px">Tgl Lahir</th>
                        <th class="text-left" style="width:100px;max-width:100px">Nama Atasan</th>
                        <th class="text-left" style="width:25px;max-width:25px">Jam</th>
                        <th class="text-left" style="width:75px;max-width:75px;">Status</th>
                        <th class="text-left" style="width:50px;max-width:50px">Action</th>
                    </tr>
                    <tr>
                    </tr>
                </thead>
            </table>
        </div>
        <div class="content-sticky">
            <CRow class="mb-5">
                <CCol sm="12">
                    <div class="tableFixHead">
                        <table>
                            <tbody v-if="datasDetail.length == 0">
                                <tr>
                                    <td class="text-center" colspan="5">
                                        {{errorMessageDetail}}
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-if="datasDetail.length != 0">
                                <tr v-for="(body, id) in datasDetail" :key="id">
                                    <td style="width:100px;max-width:100px">
                                        <div class="row no-gutters">
                                            <div class="col-12 ellps">
                                                <span>{{body.nama}}</span>
                                            </div>
                                            <div class="col-12">
                                                <span style="font-size:12px; color:grey">{{body.nik}}</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td style="width:75px;max-width:75px">{{body.noKtp}}</td>
                                    <td style="width:60px;max-width:60px">{{body.tanggalLahir}}</td>
                                    <td style="width:100px;max-width:100px">{{body.namaAtasan}}</td>
                                    <td style="width:25px;max-width:25px">{{body.jam}}</td>
                                    <td :style="'color:'+body.color" style="width:75px;max-width:75px">{{body.status}}</td>
                                    <td style="width:50px;max-width:50px">
                                        <div class="text-center">
                                            <CButton v-if="body.edit == 'Y'" @click="openModalHasil(id)" class="btn btn-edit">Edit</CButton>
                                            <CButton v-if="body.edit == 'V'" @click="openModalHasil(id)" class="btn btn-edit">Result</CButton>
                                            <CRow v-if="body.edit == 'D'">
                                                <CCol sm="12">
                                                    <CButton @click="openModalHadir(id)" class="btn btn-edit">Hadir</CButton>
                                                </CCol>
                                                <CCol sm="12 mt-1">
                                                    <CButton @click="openModalDelete(id)" class="btn btn-edit">Hapus</CButton>
                                                </CCol>
                                            </CRow>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </CCol>
            </CRow>
        </div>
    </div>
</div>
</template>

<script>
import Tables from '../../../component/tableDaftarTes'
import {DataApi, DataApiUpload} from "../../../service/DataApi";
import { ModelSelect } from 'vue-search-select'

const xlsx = require('json-as-xlsx')
export default {
    components: {
        Tables,
        ModelSelect
    },
    data() {
        return {
            success: true,
            itemHeight: 39,
            // data search pegawai
            idPegawai: '',

            // data search pegawai
            dataAddPegawai: [],
            titleAddPegawai:"Pilih Peserta",
            selectedItemAddPegawai: null,
            selectedAddPegawai: 0,
            queryAddPegawai: '',
            visibleAddPegawai: false,
            idAddPegawai: '',
            noKtpAddPegawai: '',
            ttlAddPegawai: '',

            // filter
            searchTanggal: '',
            searchKantor: '',
            dataJenisTest: [],
            jenisTest: {
                value: '',
                text: ''
            },

            refreshIcon: require('../../../assets/menu/icon_refresh.svg'),
            backIcon: require('../../../assets/menu/icon_goback.svg'),
            moreIcon: require('../../../assets/menu/icon_more.svg'),
            closeIcon: require('../../../assets/menu/icon_close.svg'),
            downloadIcon: require('../../../assets/menu/icon_download_excel.svg'),
            dataTh: ['Nama Kantor', 'Jenis Tes', 'Tanggal', 'Status', 'Action'],
            dataTd: ['kantor', 'keteranganJenisTest', 'tanggal', 'tambah', 'action'],
            styleTable: ['200px', '200px', '100px', '200px', '100px'],
            classReload: 'reloadOff',
            goArea: true,
            loading: false,
            alertMess: '',
            currentAlertCounter: 0,


            // pagination
            page: 1,
            size: 20,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,

            // pagination Detail
            pageDetail: 1,
            sizeDetail: 20,
            totalRowDetail: 0,
            totalPageDetail: 1,
            firstPageDetail: 0,
            lastPageDetail: 0,

            idKantor: '',
            tanggalKantor: '',
            idJenis: '',
            flagAddKantor: '',
            dataTanggal: '',
            dataNamaKantor: '',
            dataTotalMendaftar: '',
            dataTotalReaktif: '',
            idJenisTes: '',
            dataJenisTes: '',
            dataTotalNonReaktif: '',
            allowImport: '',
            dataFilterJam: [],
            filterJam: {
                value: '',
                text: ''
            },
            dataFilterStatus: [],
            filterStatus: {
                value: '',
                text: ''
            },
            
            // datas
            datas: [],
            datasDetail: [],

            //error
            errorMessage: '',
            errorMessageDetail: '',

            // add
            modalAdd: false,
            dataJadwal: [],
            jadwal: {
                value: '',
                text: ''
            },

            modalHasil: false,
            modalDelete: false,
            modalHadir: false,
            dataShowHasil: '',
            unixHasil: '',
            modalImport: false,

            filesImport: '',
            payloadImport: '',

            flagImport: false,
            dataImport: [],
            dataJumlahValid: '',
            dataJumlahTidakValid: '',
            dataJumlahReaktif: '',
            dataJumlahNonReaktif: '',
            totalDataImport: '',

            dataUrlCopy: '',
            flagCopy: false,
            flagSearch: false,
            flagSearchDetail: false,

            file: '',
            fileName: '',
            fileSize: '',
            urlFile: '',
        }
    },
    computed: {
        matchesAddPegawai() {
            if (this.queryAddPegawai == '') {
                return [];
            }
            return this.dataAddPegawai.filter((item) => item['text'].toLowerCase().includes(this.queryAddPegawai.toLowerCase()))
        },
    },
    watch: {
        page() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        searchKantor() {
            this.flagSearch = true
        },
        searchTanggal() {
            this.flagSearch = true
        },
        jenisTest() {
            this.flagSearch = true
        },
        pageDetail() {
            window.scroll({
                top:350,
                left: 0,
                behavior: 'smooth'
            });
        },
        idPegawai() {
            this.flagSearchDetail = true
        },
        filterJam() {
            this.flagSearchDetail = true
        },
        filterStatus() {
            this.flagSearchDetail = true
        },
        queryAddPegawai() {
            if(this.queryAddPegawai == '') {
                this.idAddPegawai = ''
                this.noKtpAddPegawai = ''
                this.ttlAddPegawai = ''
                this.newKtp = ''
                this.newTtl = ''
            }
            this.getDataAddPegawai()
        },
        goArea() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        modalImport() {
            if(this.modalImport == false) {
                this.flagImport = false
                this.dataImport = []
                this.dataJumlahValid = ''
                this.dataJumlahTidakValid = ''
                this.dataJumlahReaktif = ''
                this.dataJumlahNonReaktif = ''
                this.totalDataImport = ''
                document.getElementById('inputFile').value = ''
            }
        }
    },
    methods: {
        /**
         * ADD PEGAWAI
         */
        getDataAddPegawai() {
            let payload = {
                bidang: '',
                jabatan: '',
                limit: 10,
                nama: this.queryAddPegawai,
                pageIn: 1,
                pegawaiId: '',
                tipePegawai: ''
            }
            DataApi.post("pegawai/get", payload)
            .then(res => {
                this.dataAddPegawai = []
                let response = res.data
                let tempData = response.data.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i].idPegawai,
                        text: tempData[i].nama + ' - ' + tempData[i].nik,
                        ktp: tempData[i].noKtp,
                        tglLahir: tempData[i].tglLahir
                    }
                    this.dataAddPegawai.push(onPush)
                }
            })
        },
        toggleVisibleAddPegawai() {
            this.visibleAddPegawai = true;
        },
        hideAddPegawai() {
            this.visibleAddPegawai = false;
        },
        toggleCloseVisibleAddPegawai() {
            setTimeout(this.hideAddPegawai, 1000);
        },
        itemClickedAddPegawai(index) {
            this.selectedAddPegawai = index;
            this.selectItemAddPegawai();
        },
        selectItemAddPegawai() {
            if (!this.matchesAddPegawai.length) {
            return;
            }
            this.selectedItemAddPegawai = this.matchesAddPegawai[this.selectedAddPegawai];
            this.visibleAddPegawai = false;
            this.queryAddPegawai = this.selectedItemAddPegawai.text
            this.idAddPegawai = this.selectedItemAddPegawai.value
            this.noKtpAddPegawai = this.selectedItemAddPegawai.ktp
            this.ttlAddPegawai = this.selectedItemAddPegawai.tglLahir
            if(this.noKtpAddPegawai == '') {
                this.newKtp = 'Y'
            } else {
                this.newKtp = 'T'
            }
            if(this.ttlAddPegawai == '') {
                this.newTtl = 'Y'
            } else {
                this.newTtl = 'T'
            }
            if (this.shouldReset) {
            this.queryAddPegawai = '';
            this.selectedAddPegawai = 0;
            }
        },
        upAddPegawai() {
            if (this.selectedAddPegawai == 0) {
            return;
            }
            this.selectedAddPegawai -= 1;
            this.scrollToItemAddPegawai();
        },
        downAddPegawai() {
            if (this.selectedAddPegawai >= this.matchesAddPegawai.length - 1) {
            return;
            }
            this.selectedAddPegawai += 1;
            this.scrollToItemAddPegawai();
        },
        scrollToItemAddPegawai() {
            this.$refs.optionsList.scrollTop = this.selectedAddPegawai * this.itemHeight;
        },

        /**
         * GET DATA
         */
        sorting(value) {
            if(value == 0) {
                function compare(a,b) {
                    if (a.kantor.toLowerCase() < b.kantor.toLowerCase()) {
                        return -1
                    }
                    if (a.kantor.toLowerCase() > b.kantor.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.tanggal.toLowerCase() < b.tanggal.toLowerCase()) {
                        return -1
                    }
                    if (a.tanggal.toLowerCase() > b.tanggal.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            }
        },
        getData() {
            if(this.flagSearch == true) {
                this.page = 1
            }
            this.$store.state.loadingScreen = true
            let limit = this.size
            let kantor = this.searchKantor
            let tanggal = this.searchTanggal
            let page = this.page
            let jenis = this.jenisTest.value

            let payload = {
                limit: limit,
                jenisTest: jenis,
                kantor: kantor,
                tanggal: tanggal,
                pageIn: page
            }
            DataApi.post("rta/daftar/lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data.data
                    this.totalRow = response.data.totalRow
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else {
                    this.datas = []
                    this.totalRow = 0
                    this.firstPage = 0
                    this.lastPage = 0
                    this.totalPage = 1
                    this.errorMessage = response.message
                }
                this.flagSearch = false
                this.$store.state.loadingScreen = false
            })
        },
        findData() {
            this.getData()
        },
        findDataDetail() {
            this.getDataDetail('null')
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
            this.getData()
        },
        movePageDetail(direction) {
            if(direction == 'prev') {
                this.pageDetail = this.pageDetail -  1
            } else {
                this.pageDetail = this.pageDetail +  1
            }
            this.getDataDetail('null')
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },
        validatePageDetail(page) {
            if(page > this.totalPageDetail) {
                this.pageDetail = this.totalPageDetail
            }
        },
        reload() {
            this.searchKantor = ''
            this.searchTanggal = ''
            this.jenisTest.text = ''
            this.jenisTest.value
            this.flagSearch = true
            this.getDataJenisTest()
            this.getData()
            if (this.classReload == 'reloadOff') {
                this.classReload = 'reloadOn'
            } else {
                this.classReload = 'reloadOff'
            }
        },

        /**
         * ADD DATA
         */
        moving() {
            setTimeout(this.moveArea, 300);
        },
        moveArea() {
            if(this.goArea == true) {
                this.goArea = false
                this.$store.state.loadingScreen = false
            } else {
                this.goArea = true
                this.dataNamaKantor = ''
                this.idKantor = ''
                this.tanggalKantor = ''
                this.idJenisTest = ''
                this.flagAddKantor = ''
                this.dataTanggal = ''
                this.dataTotalMendaftar = ''
                this.dataJenisTes = ''
                this.idJenisTes = ''
                this.dataTotalReaktif = ''
                this.dataTotalNonReaktif = ''
                this.allowImport = ''
                this.dataFilterJam = []
                this.filterJam.value = ''
                this.filterJam.text = ''
                this.dataFilterStatus = []
                this.filterStatus.value = ''
                this.filterStatus.text = ''
                this.dataJadwal = []
                this.jadwal.value = ''
                this.jadwal.text = ''
                this.pageDetail = 1
                this.sizeDetail = 20
                this.totalRowDetail = 0
                this.totalPageDetail = 1
                this.firstPageDetail = 0
                this.lastPageDetail = 0
                this.idPegawai = ''
                this.datasDetail = ''
                this.errorMessage = 'Find Your Data'
                this.imageQR = ''
                this.dataUrlCopy = ''
                this.flagCopy = false
            }
        },

        /**
         * EDIT DATA
         */
        editData(value) {
            let generate = this.datas[value]
            this.idKantor = generate.idKantor
            this.idJenis = generate.idJenisTest
            this.tanggalKantor = generate.tanggal
            this.flagAddKantor = generate.tambah
            this.errorMessageDetail = 'Find Your Data'
            this.getFilterDate()
            this.getQRCode()
            // this.getDataJadwal()
            this.getDataUrlLink()
        },
        getFilterDate() {
            let payload = {
                idKantor: this.idKantor,
                tanggal: this.tanggalKantor,
                jenisTest: this.idJenis
            }
            DataApi.post("rta/daftar/detail/lihat", payload)
            .then(res => {
                this.dataFilterStatus = []
                this.dataFilterJam = []
                this.dataJadwal = []
                let response = res.data
                if(response.success == true) {
                    let onPushJam = {
                        value: '',
                        text: 'Semua Jam'
                    }
                    let onPushStatus = {
                        value: '',
                        text: 'Semua Status'
                    }
                    this.dataFilterJam.push(onPushJam)
                    this.dataFilterStatus.push(onPushStatus)
                    let datas = response.data
                    let temp = datas.data
                    let status = datas.listKeterangan
                    var i = 0
                    for(i=0;i<temp.length;i++) {
                        let keep = {
                            value: temp[i].unix,
                            text: temp[i].jam
                        }
                        this.dataFilterJam.push(keep)
                        this.dataJadwal.push(keep)
                    }
                    var j = 0
                    for(j=0;j<status.length;j++) {
                        let save = {
                            value: status[j].unix,
                            text: status[j].keterangan
                        }
                        this.dataFilterStatus.push(save)
                    }
                    this.dataNamaKantor = datas.kantor
                    this.dataTanggal = datas.tanggal
                    this.dataTotalMendaftar = datas.mendaftar
                    this.dataJenisTes = datas.keteranganJenisTest
                    this.idJenisTes = datas.idJenisTest
                    this.dataTotalReaktif = datas.reaktif
                    this.dataTotalNonReaktif = datas.nonReaktif
                    this.allowImport = datas.allowImport
                }
            })
        },
        getQRCode() {
            let payload = {
                idKantor: this.idKantor,
                tanggal: this.tanggalKantor,
                jenisTest: this.idJenis
            }
            this.$store.state.loadingScreen = true
            DataApi.post("rta/qrcode/image", payload)
            .then(res => {
                let temp = res.data
                this.imageQR = temp.data
                this.moving()
            })
        },
        getDataUrlLink() {
            let payload = {
                idKantor: this.idKantor,
                tanggal: this.tanggalKantor,
                jenisTest: this.idJenis
            }
            DataApi.post("rta/jadwal/generate/link", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.dataUrlCopy = response.data.url
                }
            })
        },
        exportPdf() {
            this.$store.state.loadingScreen = true
            let payload = {
                idKantor: this.idKantor,
                tanggal: this.tanggalKantor,
                jenisTest: this.idJenis
            }
            DataApi.post("rta/export/jadwal/pdf", payload , {responseType: 'blob'})
            .then(res => {
                let response = res.data
                const url = URL.createObjectURL(new Blob([response], {
                    type: 'application/pdf'
                }))
                window.open(url)
                this.$store.state.loadingScreen = false
            })
        },
        getDataDetail(inttt) {
            if(this.flagSearchDetail == true) {
                this.pageDetail = 1
            }
            if(inttt == 'null') {
                this.$store.state.loadingScreen = true
            }
            let limit = this.sizeDetail
            let page = this.pageDetail

            let payload = {
                idKantor: this.idKantor,
                idPegawai: this.idPegawai,
                limit: limit,
                pageIn: page,
                status: this.filterStatus.value,
                tanggal: this.tanggalKantor,
                jenisTest: this.idJenis,
                unixJadwal: this.filterJam.value
            }
            DataApi.post("rta/absen/lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datasDetail = response.data.data
                    this.totalRowDetail = response.data.row
                    this.firstPageDetail = (((this.pageDetail - 1) * this.sizeDetail) + 1 )
                    this.lastPageDetail = (((this.pageDetail - 1) * this.sizeDetail) + this.datasDetail.length )
                    this.totalPageDetail = Math.floor(this.totalRowDetail/this.sizeDetail)
                    let modAr = this.totalRowDetail%this.sizeDetail
                    if(modAr != 0) {
                        this.totalPageDetail = this.totalPageDetail + 1
                    } else {
                        //
                    }
                } else {
                    this.datasDetail = []
                    this.totalRowDetail = 0
                    this.firstPageDetail = 0
                    this.lastPageDetail = 0
                    this.totalPageDetail = 1
                    this.errorMessageDetail = response.message
                }
                this.flagSearchDetail = false
                this.$store.state.loadingScreen = false
            })
        },
        openModalHasil(id) {
            this.dataShowHasil = id
            this.unixHasil = this.datasDetail[id].unix
            this.modalHasil = true
        },
        openModalDelete(id) {
            this.dataShowHasil = id
            this.unixHasil = this.datasDetail[id].unix
            this.modalDelete = true
        },
        openModalHadir(id) {
            this.dataShowHasil = id
            this.modalHadir = true
        },
        submitHadir() {
            this.$store.state.loadingScreen = true
            let payload = {
                unixDaftar: this.datasDetail[this.dataShowHasil].unix
            }
            DataApi.post("rta/absen/simpan", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.success = true
                    } else {
                        this.success = false
                    }
                    this.alertMess = response.data.Data2
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.modalHadir = false
                this.getDataDetail('null')
                this.currentAlertCounter = 3
                this.$store.state.loadingScreen = false
            })
        },
        deletePeserta() {
            this.$store.state.loadingScreen = true
            let data = this.datasDetail[this.dataShowHasil]
            let payload = {
                hadir: 'T',
                idPegawai: data.idPegawai,
                noKtp: data.noKtp,
                tanggalLahir: data.tanggalLahir,
                tipe: 'D',
                unixDaftar: data.unix,
                unixJadwal: '',
                updateKtp: 'T',
                updateTanggalLahir: 'T'
            }
            DataApi.post("rta/daftar/simpan", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.success = true
                    } else {
                        this.success = false
                    }
                    this.alertMess = response.data.Data2
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.modalDelete = false
                this.getDataDetail('null')
                this.currentAlertCounter = 3
                this.$store.state.loadingScreen = false
            })
        },
        closeAdd() {
            this.modalAdd = false
            this.jadwal.value = ''
            this.jadwal.text = ''
            this.dataJadwal = []
            this.noKtpAddPegawai = ''
            this.ttlAddPegawai = ''
            this.queryAddPegawai = ''
            this.idAddPegawai = ''
            this.newKtp = ''
            this.newTtl = ''
            this.getFilterDate()
            // this.getDataJadwal()
        },
        // getDataJadwal() {
        //     let limit = 9999
        //     let kantor = this.idKantor
        //     let tanggal = this.tanggalKantor
        //     let page = 1

        //     let payload = {
        //         limit: limit,
        //         kantor: kantor,
        //         tanggal: tanggal,
        //         pageIn: page
        //     }
        //     DataApi.post("rta/jadwal/lihat", payload)
        //     .then(res => {
        //         this.dataJadwal = []
        //         let response = res.data
        //         if(response.success == true) {
        //             let temp = response.data.data
        //             var i = 0
        //             for(i=0;i<temp.length;i++) {
        //                 let onPush = {
        //                     value: temp[i].unix,
        //                     text: temp[i].jam
        //                 }
        //                 this.dataJadwal.push(onPush)
        //             }
        //         }
        //     })
        // },
        getDownload() {
            this.$store.state.loadingScreen = true
            let limit = this.totalRowDetail
            let page = 1

            let payload = {
                idKantor: this.idKantor,
                idPegawai: this.idPegawai,
                limit: limit,
                pageIn: page,
                status: '',
                tanggal: this.tanggalKantor,
                jenisTest: this.idJenis,
                unixJadwal: this.filterJam.value
            }
            DataApi.post("rta/absen/lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    let downloads = response.data.data
                    let fileName = 'Daftar Peserta Tes ' + this.dataNamaKantor + ' Tanggal ' + this.tanggalKantor
                    let data = [
                        {
                            sheet: 'Peserta',
                            columns: [
                                { label: 'Nama Peserta', value: 'nama'  },
                                { label: 'NIP', value: 'nik' },
                                { label: 'Nomor KTP', value: 'noKtp' },
                                { label: 'Tanggal Lahir', value: 'tanggalLahir' },
                                { label: 'Nama Atasan', value: 'namaAtasan' },
                                { label: 'Jam Pelaksanaan', value: 'jam' },
                                { label: 'Status (Belum Hadir atau Hadir atau Reaktif/Positif atau Non Reaktif/Negatif)', value: 'status' },
                            ],
                            content: downloads
                        }
                    ]
                    let settings = {
                        fileName: fileName
                    }
                    xlsx(data, settings)
                }
                this.$store.state.loadingScreen = false
            })
        },
        addPeserta() {
            this.$store.state.loadingScreen = true
            let payload = {
                hadir: 'T',
                idPegawai: this.idAddPegawai,
                noKtp: this.noKtpAddPegawai,
                tanggalLahir: this.ttlAddPegawai,
                tipe: 'C',
                unixJadwal: this.jadwal.value,
                updateKtp: this.newKtp,
                updateTanggalLahir: this.newTtl
            }
            DataApi.post("rta/daftar/simpan", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.success = true
                    } else {
                        this.success = false
                    }
                    this.alertMess = response.data.Data2
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.getFilterDate()
                this.closeAdd()
                this.getDataDetail('null')
                this.currentAlertCounter = 3
                this.$store.state.loadingScreen = false
            })
        },
        submitHasil(hasil) {
            this.$store.state.loadingScreen = true
            let payload = {
                unix: this.unixHasil,
                hasilRta: hasil
            }
            DataApi.post("rta/hasil/simpan", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.success = true
                    } else {
                        this.success = false
                    }
                    this.alertMess = response.data.Data2
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.getFilterDate()
                this.getDataDetail('null')
                this.modalHasil = false
                this.currentAlertCounter = 3
                this.$store.state.loadingScreen = false
            })
        },
        importExcel() {
            this.modalImport = true
        },
        closeModalImport() {
            this.modalImport = false
        },
        submitImport() {
            this.$store.state.loadingScreen = true
            let filesImport = document.getElementById('inputFile').files[0];
            var fd = new FormData();
            fd.append('file', filesImport);
            let param = '?' + 'tanggal=' + this.tanggalKantor + '&' + 'kantor=' + this.idKantor + '&' + 'jenisTest=' + this.idJenis
            DataApi.post("rta/import/hasil/preview" + param, fd)
            .then(res => {
                let temp = res.data
                if(temp.success == true) {
                    let response = temp.data
                    this.dataImport = response.data
                    this.dataJumlahValid = response.jumlahValid
                    this.dataJumlahTidakValid = response.jumlahTidakValid
                    this.dataJumlahReaktif = response.totalReaktif
                    this.dataJumlahNonReaktif = response.totalNonReaktif
                    this.totalDataImport = this.dataImport.length
                    this.flagImport = true
                }
                this.$store.state.loadingScreen = false
            })
        },
        simpanImport() {
            this.$store.state.loadingScreen = true
            let payload = {
                data: this.dataImport,
                jumlahTidakValid: this.jumlahTidakValid,
                jumlahValid: this.jumlahValid,
                kantor: this.idKantor,
                tanggal: this.tanggalKantor,
                jenisTest: this.idJenis
            }
            DataApi.post("rta/import/hasil", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.success = true
                    this.alertMess = response.data
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.modalImport = false
                this.getDataDetail('null')
                this.currentAlertCounter = 3
                this.$store.state.loadingScreen = false
            })
        },
        exportTemplate() {
            this.$store.state.loadingScreen = true
            let fileName = 'Template Import Hasil Tes'
            let downloads = [
                { nama: 'Nama Peserta A', nik: 'NIPX01', hasil: 'Positif' },
                { nama: 'Nama Peserta B', nik: 'NIPX02', hasil: 'Negatif' },
                { nama: 'Nama Peserta C', nik: 'NIPX03', hasil: 'Negatif' }
            ]
            let data = [
                {
                    sheet: 'Daftar Hasil',
                    columns: [
                        { label: 'Nama Peserta', value: 'nama' },
                        { label: 'NIP', value: 'nik' },
                        { label: 'Hasil Tes (Negatif, Positif) atau (Non Reaktif, Reaktif)', value: 'hasil' },
                    ],
                    content: downloads
                }
            ]
            let settings = {
                fileName: fileName
            }
            xlsx(data, settings)
            this.$store.state.loadingScreen = false
        },
        copyUrl() {
            this.flagCopy = true
            let copys = this.dataUrlCopy
            navigator.clipboard.writeText(copys)
        },
        getDataJenisTest() {
            DataApi.get("rta/jenis/lihat")
            .then(res => {

                this.dataJenisTest = [
                    { value: '', text: 'Semua' }
                ]
                let response = res.data
                if(response.success == true) {
                    let temp = response.data
                    var i 
                    for(i=0;i<temp.length;i++) {
                        let onPush = {
                            value: temp[i].unix,
                            text: temp[i].keterangan
                        }
                        this.dataJenisTest.push(onPush)
                    }
                }
            })
        },
        showPdfHasil(unix) {
            this.$store.state.loadingScreen = true
            let payload = {
                unix: unix
            }
            DataApi.post("/rta/hasil/export/pdf", payload , {responseType: 'blob'})
            .then(res => {
                let response = res.data
                const url = URL.createObjectURL(new Blob([response], {
                    type: 'application/pdf'
                }))
                window.open(url)
                this.$store.state.loadingScreen = false
            })
        },
        showPdfHasilKlinik(value) {
            this.$store.state.loadingScreen = true
            DataApiUpload.get('load/' + value)
            .then( res => {
                let openWindow = res.config.baseURL + res.config.url
                window.open(openWindow)
                this.$store.state.loadingScreen = false
            })
        },
        loadFile(e) {
            this.$store.state.loadingScreen = true
            let files = document.getElementById('inputFilePDF').files[0]
            this.file = files
            this.fileName = files.name
            this.fileSize = files.size
            this.uploadFile()
        },
        uploadFile() {
            if(parseInt(this.fileSize) > 2000000) {
                alert("Maaf, Maksimal lampiran 2MB")
                setTimeout(this.clearFile, 200);
                this.$store.state.loadingScreen = false
            } else {
                this.prosessUpload()
            }
        },
        prosessUpload() {
            if (this.file != '') {
                let imageData = this.file

                const fd = new FormData()
                fd.append('file', imageData)

                DataApiUpload.post('upload', fd)
                .then(res => {
                    let response = res.data
                    if(response.success == true) {
                        this.urlFile = response.data.path
                        this.savePDF(this.urlFile)
                    } else {
                        alert('Upload File Failed !')
                        this.$store.state.loadingScreen = false
                    }
                });
            } else if(this.file == '') {
                this.urlFile = ''
                this.$store.state.loadingScreen = false
            }
        },
        savePDF(url) {
            let unix = this.datasDetail[this.dataShowHasil].unix
            let payload = {
                unix: unix,
                urlFile: url
            }
            DataApi.post("rta/hasil/file/simpan", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.getDataDetail('submit')
                    } else {
                        alert("Gagal Simpan File")
                        this.$store.state.loadingScreen = false
                    }
                } else {
                    alert("Gagal Simpan File")
                    this.$store.state.loadingScreen = false
                }
            })
        },
        clearFile() {
            this.fileName = ''
            this.fileSize = ''
            this.urlFile = ''
            this.file = ''
        },
    },
    mounted() {
        this.errorMessage = 'Find Your Data'
        this.getDataJenisTest()
    },
}
</script>
<style scoped>
input[type="checkbox"] {
    width: 16px;
    height: 16px;
    margin-right: 8px;
}
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
@media screen and (min-width: 1253px) and (max-width: 1358px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1168px) and (max-width: 1252px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1097px) and (max-width: 1167px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1036px) and (max-width: 1096px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 992px) and (max-width: 1035px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1359px){
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
.btn-search {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}
.btn-add {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-add:hover {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.btn-cancel {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(-180deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(180deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 6px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 6px;
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
div.sticky2 {
    position: -webkit-sticky;
    position: sticky;
    top: 105px;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}
.area-edit {
    background-color: white;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
}
.area-back {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input label {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
    font-weight: 600;
    margin-bottom: 12px;
}
.area-input input, .area-input .model-select, .area-input .autocomplete {
    background-color: white;
    margin-bottom: 20px;
}
.area-button-submit {
    padding-left: 20px;
    padding-bottom: 20px;
    padding-top: 32px;
}
.select-invalid {
    border: 1px solid #e55353 !important;
}
.select-valid {
    border: 1px solid #2eb85c !important;
}
.btn-edit-submit {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
    font-size: 14px;
}
.cards-image {
    position: absolute;
    text-align: center;
    font-size: 27px;
    color: rgba(96, 96, 96, 1);
    line-height: 50px;
    border: 1px dotted rgba(221, 221, 221, 1);
    width: 56px !important;
    background-color: rgba(250, 250, 250, 1);
    height: 56px !important;
}
.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 32px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 40px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: scroll;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.ellps {
    overflow-x: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
table {
    width: 100%;
}
table thead tr {
    background-color: rgba(244, 244, 244, 1);
}
thead th {
    padding-top: 16px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 16px;
}
tbody td {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 20px;
    padding-right: 20px;
}
td,th {
    overflow-x: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
    border: 1px solid rgba(238, 238, 238, 1);
    font-size: 14px;
}
tr:nth-child(even) {
    background-color: rgba(252, 252, 252, 1);
}
.btn-edit {
    border-radius: 4px;
    border: 1px solid rgba(154, 154, 154, 1);
    background-color: white;
    color: black;
    font-size: 14px;
    font-weight: 600;
    width: 80px;
    height: 32px;
}
.btn-edit:hover {
    border-radius: 4px;
    border: 1px solid rgba(154, 154, 154, 1);
    background-color: rgba(154, 154, 154, 1);
    color: white;
    font-size: 14px;
    font-weight: 600;
    width: 80px;
    height: 32px;
}
::v-deep .modal-header {
    border-bottom: none !important;
}
.headers-modal {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(16, 16, 16, 1);
}
</style>